import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function guidValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    const value = control.value;

    if (!value) {
      return null;
    }

    if (/^[a-zA-Z0-9]{8}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{4}-[a-zA-Z0-9]{12}$/.test(value)) {
      return null;
    }

    return { guid: true };
  };
}
